import { MarketingContentFormat, type MarketingContentFormatType } from '@/api/admin-marketing-content-types'
import { Badge } from '@/components/base/badge'
import { useI18n } from '@/i18n/i18n-react'
import { clx } from '@/utils/clx'

export function FormatBadge({
	format,
	size = '2xsmall',
	className
}: {
	format: MarketingContentFormatType
	size?: '2xsmall' | 'small'
	className?: string
}) {
	const { L } = useI18n()
	return (
		<Badge
			size={size}
			color={format === MarketingContentFormat.CheckoutBackground ? 'purple' : 'blue'}
			className={clx('shrink-0 whitespace-nowrap', className)}
		>
			{L.Marketing.Content.Format(format)}
		</Badge>
	)
}
